// extracted by mini-css-extract-plugin
export default {"form_modal_title":"styles_form_modal_title__JOCrA","modal_body":"styles_modal_body__tTXzn"};